import React from 'react';
import { useState } from 'react';
import logo from '../../../src/assets/images/logo/ui-en.png';
// import {Nav, NavbarContainer, NavLogo} from './NavbarElements';

const NavbarLP = () => {

  return (

    <div className="custom-container">
      <div className="row">
        <div className="col-12">
          <nav className="navbar navbar-light p-0" id="navbar-example2">
            <a className="navbar-brand" href="javascript:void(0)">
              <img className="img-fluid" src={logo} alt="" />
            </a>
          </nav>
        </div>
      </div>
    </div>

    

  )
}

export default NavbarLP
